import { Checkbox, CheckboxProps } from 'antd';
import { FC } from 'react';

const TcCheckbox: FC<CheckboxProps> = ({ ...props }) => {
  return <Checkbox {...props} />;
};

export default TcCheckbox;
